if (!customElements.get('cart-upsells-slider')) {
  class CartUpsellsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        this.onCartUpdate();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    onCartUpdate() {
      fetch(`${routes.cart_url}?section_id=cart-upsells-slider`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.innerHTML = html.querySelector('#cart-upsells-slider').innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define('cart-upsells-slider', CartUpsellsSlider);
}